import { Observable } from 'rxjs';

import {
  JITMeetConferenceCommand,
  JITMeetConferenceEvent,
} from '../../models/jit-meet/conference/jit-meet-conference.model';

export abstract class JITMeetConferenceSession {
  abstract readonly events$: Observable<JITMeetConferenceEvent>;

  abstract readonly isDisposed: boolean;

  abstract execute(
    command: JITMeetConferenceCommand,
    ...args: readonly unknown[]
  ): void;

  /**
   * Abandona únicamente la sesión local.
   *
   * Se utiliza para la salida voluntaria del paciente.
   * No finaliza la sala ni desconecta al profesional.
   */
  abstract leave(): Promise<void>;

  /**
   * Finaliza la conferencia para todos los participantes.
   *
   * Solo debe utilizarse desde el flujo profesional moderador.
   */
  abstract finish(): Promise<void>;

  /** Libera inmediatamente los recursos técnicos. */
  abstract dispose(): void;
}